import React, { useRef } from 'react';
import styled from 'styled-components';
import { TLinks } from '../../../store/interactive/types';
import { RGBA_COLORS } from '../../../utils/colors';
import { DefButton } from '../../ui/Buttons';

interface LinkProps {
  link: TLinks;
}

export const Links: React.FC<LinkProps> = ({ link }) => {
  const ref = useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (ref.current && link.body) {
      ref.current.innerHTML = link.body;
    }
  }, [ref, link.body]);

  return (
    <WrapperS>
      <div>
        <h2>{link.title}</h2>
        <div style={{ marginBottom: '10px', textAlign: 'left' }} ref={ref} />
        <a href={link.link_button} rel="noreferrer" target="_blank">
          <DefButton title={link.name_button} onClick={() => {}} type="button" />
        </a>
      </div>
    </WrapperS>
  );
};

const WrapperS = styled.div`
  padding: 20px;
  flex: 1;
  overflow: auto;
  text-align: left;
  padding-bottom: 300px;
  & > * {
    margin-bottom: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    padding-bottom: 20px;
    text-align: center;
  }
  img {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
  }
  a {
    margin-bottom: 0px;
    font-weight: 500;
    text-align: center;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid rgb(233, 233, 233);
    white-space: nowrap;
    line-height: 1.5;
    padding: 0px 25px;
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    border-radius: 0;
    height: 36px;
    user-select: none;
    position: relative;
    transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
    color: #fff;
    background-color: ${RGBA_COLORS.getAccent()};
    border-color: ${RGBA_COLORS.getAccent()};
    margin-top: 20px;

    &:hover {
      color: #fff;
      background-color: ${RGBA_COLORS.getAccent(0.9)};
    }
    &:active {
      color: #fff;
      background-color: ${RGBA_COLORS.getAccent(0.7)};
      border-color: ${RGBA_COLORS.getAccent(0.7)};
    }
  }
`;
